import { render } from "./MetaSection.vue?vue&type=template&id=eac0e542&scoped=true"
import script from "./MetaSection.vue?vue&type=script&lang=js"
export * from "./MetaSection.vue?vue&type=script&lang=js"

import "./MetaSection.vue?vue&type=style&index=0&id=eac0e542&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac0e542"]])

export default __exports__